import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/assets/global.css'
import SweetAlertIcons from 'vue-sweetalert-icons';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  SweetAlertIcons,
  render: h => h(App)
}).$mount('#app')